import { Box, IconButton, Link, Tooltip } from '@material-ui/core'

import React from 'react'
import { SOCIAL_LINKS } from '../../utils/constants/socials'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  logo: {
    padding: 0,
    '&:hover': {
      focus: 'none',
      backgroundColor: '#fff',
    },
  },
})

export default function SocialLogos() {
  const classes = useStyles()

  const SocialLink = ({ social }) => {
    const { link, message, icon } = SOCIAL_LINKS[social]
    return (
      <Tooltip title={message} aria-label={message}>
        <Box mx={1}>
          <IconButton aria-label={message} className={classes.logo}>
            <Link href={link} underline="none" target="_blank" rel="noopener">
              {icon}
            </Link>
          </IconButton>
        </Box>
      </Tooltip>
    )
  }

  return (
    <Box display="flex" justifyContent="center">
      <SocialLink social="email" />
    </Box>
  )
}
